import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Error404 from '../../components/Error/Error404';
import { getPublicRoutes } from './publicRoutes';
import { getAdminRoutes } from './adminRoutes';
import { getMobileRoutes } from './mobileRoutes';

export default function AppRoutes({ native }) {
  return (
    <Routes>
      {getPublicRoutes(native)}
      {getAdminRoutes()}
      {getMobileRoutes()}
      <Route path="/404" element={<Error404 />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
